import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from "react-router-dom";
import AuthRedirect from "./AuthRedirect";
import Layout from "./Layout";
import loadable from "@loadable/component";

const AboutUs = loadable(() => import("../pages/about-us"));
const Account = loadable(() => import("../pages/account"));
const Apply = loadable(() => import("../pages/apply"));
const BugReport = loadable(() => import("../pages/bug-report"));
const ConfirmPassword = loadable(() => import("../pages/confirm-password"));
const ContactUs = loadable(() => import("../pages/contact-us"));
const Default = loadable(() => import("../pages/default"));
const Faq = loadable(() => import("../pages/faq"));
const ForgotPassword = loadable(() => import("../pages/forgot-password"));
const Index = loadable(() => import("../pages/index"));
const Privacy = loadable(() => import("../pages/privacy"));
const Recs = loadable(() => import("../pages/recs"));
const SignIn = loadable(() => import("../pages/signin"));
const SignUp = loadable(() => import("../pages/signup"));
const EDHREChat = loadable(() => import("../pages/edhrechat"));

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<Layout />} path="/">
      <Route element={<Index />} index />
      <Route element={<AuthRedirect />} path="__/auth/action" />
      <Route element={<AboutUs />} path="about-us" />
      <Route element={<Account />} path="account" />
      <Route element={<Apply />} path="apply" />
      <Route element={<BugReport />} path="bug-report" />
      <Route element={<ConfirmPassword />} path="confirm-password" />
      <Route element={<ContactUs />} path="contact-us" />
      <Route element={<EDHREChat />} path="chat" />
      <Route element={<Faq />} path="faq" />
      <Route element={<ForgotPassword />} path="forgot-password" />
      <Route element={<Privacy />} path="privacy" />
      <Route element={<Recs />} path="recs" />
      <Route element={<SignIn />} path="signin" />
      <Route element={<SignUp />} path="signup" />
      <Route element={<Default />} path=":dir" />
      <Route element={<Default />} path=":dir/:page" />
      <Route element={<Default />} path=":dir/:page/:subpage" />
    </Route>
  )
);

const Router = () => <RouterProvider router={router} />;

export default Router;
